<script setup>
import {ref} from 'vue'
import Tips12 from "@/components/NewPC/Tips12.vue";
import getApk from '@/utils/getApk';
import moment from 'moment'
import CustomVideo from "@/components/NewPC/CustomVideo.vue";
import {useRouter} from "vue-router";
import {useTgaStore} from "@/store/tga";
import useAccount from "@/store/account";
const tga = useTgaStore()
const accountStore = useAccount();
const CustomVideoRef = ref(null);
const Tips12Ref = ref(null);
const router = useRouter()

const showTips = () => {
  Tips12Ref.value?.open();
}


const handleDownAndroid = () => {
  tga.tgaTrack('web_campaigns_event', {
    web_campaigns_op: 'pc_android_download',
    account: accountStore.getterAccount() ? accountStore.getterAccount():'未绑定',
    gps1: accountStore.getterAccount() ? accountStore.account.invite_code:null,
    gps2: "首页"
  })
  // 十秒钟后的时间戳
  const timestamp = moment(moment().add(900, 'seconds').format('YYYY-MM-DD HH:mm:ss')).unix().toString(16)
  const aUrl = getApk(timestamp, "/res-patch/release/jqys_v4/apks/projectb_ysa_release.apk")
  location.href = aUrl
}

const handleDownIos = () => {
  // 用户存在，上报
  tga.tgaTrack('web_campaigns_event', {
    web_campaigns_op: 'pc_ios_download',
    account: accountStore.getterAccount() ? accountStore.getterAccount():'未绑定',
    gps1: accountStore.getterAccount() ? accountStore.account.invite_code:null,
    gps2: "首页"
  })

  window.location.href = "https://apps.apple.com/cn/app/id6443768967"
}

const handlePlay = () => {
  CustomVideoRef.value?.open('https://jqys-files.racoondigi.cn/campaigns_resources/mp4/Guanwang20250410.mp4');
}

const handleJumpGift = () => {
  const element = document.getElementById('gift');
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
}

const handleJumpTopUp = () => {
  router.push({path: '/top-up'})
}
</script>

<template>
  <div class="logo_container">
    <div>
      <img class="logo_icon" src="@/assets/newPc/logo.png" alt="">
      <img class="logo_text" src="@/assets/newPc/logo_text.png" alt="">
    </div>
    <img class="play_icon" src="@/assets/newPc/play_icon.png" @click="handlePlay" alt="">
  </div>
  <div class="gift_container">
    <img class="gift_icon" src="@/assets/newPc/gift_entry.png" @click="handleJumpGift" alt="">
    <div>
      <img class="android_icon" @click="handleDownAndroid" src="@/assets/newPc/android_icon.png" alt="">
      <img class="ios_icon" @click="handleDownIos" src="@/assets/newPc/ios_icon.png" alt="">
    </div>
    <img class="top_up_icon" src="@/assets/newPc/top_up_icon.png" @click="handleJumpTopUp" alt="">
  </div>
  <div class="guide_container">
    <div>下滑浏览 领福利</div>
    <img class="more_icon" src="@/assets/newPc/more_icon.png" alt="">
  </div>
  <img class="tip_12" src="@/assets/newPc/tip_12.png" @click="showTips" alt="">

  <tips12 ref="Tips12Ref" />

  <custom-video ref="CustomVideoRef" />
</template>

<style scoped lang="scss">

.logo_container {
  padding-top: 11.5546875vw;
  padding-left: 6.5625vw;
  display: flex;
  flex-direction: row;
  align-items: center;

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .logo_icon {
    width: 20.390625vw;
    height: auto;
  }

  .logo_text {
    width: 24.84375vw;
    height: auto;
  }

  .play_icon {
    width: 5.7421875vw;
    height: 5.1953125vw;
    cursor: pointer;
  }
}

.gift_container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 7.7734375vw;
  margin-top: 6.2109375vw;


  div {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    height: 6.171875vw;
    margin-right: 0.390625vw;
  }

  .gift_icon {
    width: 9.1015625vw;
    height: 6.171875vw;
    cursor: pointer;
  }
  .android_icon, .ios_icon {
    width: 9.375vw;
    height: 2.578125vw;
    cursor: pointer;
  }
  .top_up_icon {
    width: 3.6328125vw;
    height: 5.546875vw;
    cursor: pointer;
  }
}
.tip_12 {
  width: 4.375vw;
  height: 5.5859375vw;
  position: absolute;
  bottom: 5.46875vw;
  right: 3.3203125vw;
  cursor: pointer;
}

.guide_container {
  margin-top: 0.8203125vw;
  padding-left: 15.2734375vw;
  display: flex;
  flex-direction: column;

  font-family: 'SourceHanSansCN-Medium';
  font-size: 0.859375vw;
  color: #fff;

  .more_icon {
    width: 2.265625vw;
    height: 1.7578125vw;
    padding-left: 2.34375vw;
    cursor: pointer;
  }
}
</style>